import React from 'react';
import { getTranslationKey } from '../../../modules/utils/helpers';

const BookingFooter: React.FC = () => (
  <div className="booking-footer text-center">
    <span>
      Powered by ©{' '}
      <a href="https://leadsuite.eu/?ref=booking" target="_blank" rel="noopener noreferrer">
        LeadSuite
      </a>{' '}
      •{' '}
      <a href="https://leadsuite.eu/impressum" target="_blank" rel="noopener noreferrer">
        {`${getTranslationKey('imprint')} & ${getTranslationKey('privacy')}`}
      </a>
    </span>
  </div>
);

export default BookingFooter;
